import { render, staticRenderFns } from "./EmptyTableContent.vue?vue&type=template&id=4ab5a199&"
import script from "./EmptyTableContent.vue?vue&type=script&lang=js&"
export * from "./EmptyTableContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports